import { useEffect, useState } from 'react';
import { useContext } from 'react';
import { AdminContext } from '../../contexts/contexAdmin';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  ModalConfirmController,
  ModalCreatingTanque,
  ModalCreatingUser,
} from '../../styles/modals';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { apiJalles } from '../../services/api';
import { HomeContext } from '../../contexts/contexHome';
import { ModalBombaTanque } from '../../styles/tanques';
import { SquareLoading } from '../../components/loaders';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { MdAddToPhotos, MdDeleteSweep, MdOutlineDeleteSweep } from 'react-icons/md';

export const CreatingUser = () => {
  const { setModalCreatingUser, modalCreatingUser, handleUsertCreation } = useContext(AdminContext);
  const [exitModal, setExitModal] = useState(false);
  const [viewPassword, setViewPassword] = useState('password');
  const [viewPassword2, setViewPassword2] = useState('password');

  const formSchema = yup.object().shape({
    email: yup.string().email(),
    usuario: yup.string().required('Nome do Usuário obrigatório'),
    nome: yup.string().required('Nome do Usuário obrigatório'),
    role: yup.string().required('Nível do Usuário obrigatório'),
    matricula: yup.string(),
    password: yup.string().required('Senha Obrigatório'),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('password'), null], 'Senhas diferentes')
      .required('Senha Obrigatório'),
  });

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(formSchema),
  });

  return (
    <ModalCreatingUser>
      <form
        onSubmit={handleSubmit(handleUsertCreation)}
        onClick={(e) => {
          e.stopPropagation(); // Impede a propagação do evento de clique para os elementos pai
        }}
        action=""
        className={`${exitModal ? 'slide-out-fwd-center-exit' : 'slide-in-elliptic-top-fwd-enter'}`}
      >
        <div className="header">
          <h2>Criar Um Novo Usuário </h2>
          <span
            className="closeModal"
            onClick={() => {
              setExitModal(!exitModal);
              setTimeout(() => {
                setModalCreatingUser(!modalCreatingUser);
                setExitModal(false);
              }, 500);
            }}
          >
            x
          </span>
        </div>
        <ul>
          <li>
            <label htmlFor="NameCreatingPivo">Email</label>
            <input id="NameCreatingPivo" type="email" {...register('email')} />
            <span className="error">{errors?.email?.message}</span>
          </li>
          <li>
            <label htmlFor="latitudeCreatingPivo">UserName</label>
            <input type="text" id="latitudeCreatingPivo" required={true} {...register('usuario')} />
            <span className="error">{errors?.usuario?.message}</span>
          </li>
          <li>
            <label htmlFor="first_name">Nome</label>
            <input type="text" id="first_name" required={true} {...register('nome')} />
            <span className="error">{errors?.nome?.message}</span>
          </li>
          <li>
            <label htmlFor="Matricula">Matricula</label>
            <input type="text" id="Matricula" {...register('matricula')} />
            <span className="error">{errors?.matricula?.message}</span>
          </li>
          <li>
            <label htmlFor="role">Nivel do Usuário</label>
            <input type="text" id="role" required={true} {...register('role')} />
            <span className="error">{errors?.role?.message}</span>
          </li>
          <li>
            <label htmlFor="longitudeCreatingPivo">Senha</label>
            <input
              id="longitudeCreatingPivo"
              type={viewPassword}
              required={true}
              {...register('password')}
            />
            <span className="error">{errors?.password?.message}</span>
            {viewPassword === 'password' ? (
              <FaEye className="viewPassword" onClick={() => setViewPassword('text')} />
            ) : (
              <FaEyeSlash className="viewPassword" onClick={() => setViewPassword('password')} />
            )}
          </li>
          <li>
            <label htmlFor="tamanhoCreatingPivo">Confimar Senha</label>
            <input
              id="tamanhoCreatingPivo"
              type={viewPassword2}
              required={true}
              {...register('confirmPassword')}
            />
            <span className="error">{errors?.confirmPassword?.message}</span>
            {viewPassword2 === 'password' ? (
              <FaEye className="viewPassword" onClick={() => setViewPassword2('text')} />
            ) : (
              <FaEyeSlash className="viewPassword" onClick={() => setViewPassword2('password')} />
            )}
          </li>
        </ul>
        <button type="submit">Criar Usuário</button>
      </form>
    </ModalCreatingUser>
  );
};

export const ModalConfirmDeleteUser = () => {
  const { modalUserDeletConfirmation, setModalUserDeletConfirmation, salveUserId, deleteUser } =
    useContext(AdminContext);

  return (
    <ModalConfirmController>
      <div className="deleteContact">
        <h2>{`Tem certeza de que deseja Deletar esse Usuário?`}</h2>
        <div>
          <button className="buttonYes" onClick={() => deleteUser(salveUserId)}>
            Sim
          </button>
          <button onClick={() => setModalUserDeletConfirmation(!modalUserDeletConfirmation)}>
            Não
          </button>
        </div>
      </div>
    </ModalConfirmController>
  );
};

export const ModalAtiveBluetooth = () => {
  const { modalBTGtw, setModalBTGtw, saveUserGtw } = useContext(AdminContext);

  const { socket } = useContext(HomeContext);

  const handleBTGtw = (id) => {
    socket.emit('Bt_gateway', {
      id: id,
    });
    setModalBTGtw(!modalBTGtw);
    toast.success('Comando Feito com sucesso', {
      position: 'top-right',
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'dark',
    });
  };

  return (
    <ModalConfirmController>
      <div className="deleteContact">
        <h2>{`Tem certeza que deseja Ativar o Bluetooth desse dispositivo?`}</h2>
        <div>
          <button className="buttonYes" onClick={() => handleBTGtw(saveUserGtw)}>
            Sim
          </button>
          <button onClick={() => setModalBTGtw(!modalBTGtw)}>Não</button>
        </div>
      </div>
    </ModalConfirmController>
  );
};

export const ModalUpdateUser = () => {
  const { modalEditUser, setModalEditUser, handleUserUpdate, salveUserId, usersSave } =
    useContext(AdminContext);
  const [exitModal, setExitModal] = useState(false);

  const formSchema = yup.object().shape({
    email: yup.string().email(),
    usuario: yup.string().required('Nome do Usuário obrigatório'),
    is_superuser: yup.boolean().required('Admin obrigatória'),
    nome: yup.string().required('Nome obrigatória'),
    is_active: yup.boolean().required('Status da Conta obrigatória'),
  });

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(formSchema),
  });

  const userInfo = usersSave.find((e) => salveUserId === e.id);
  return (
    <ModalCreatingUser>
      <form
        onSubmit={handleSubmit(handleUserUpdate)}
        onClick={(e) => {
          e.stopPropagation(); // Impede a propagação do evento de clique para os elementos pai
        }}
        action=""
        className={`${exitModal ? 'slide-out-fwd-center-exit' : 'slide-in-elliptic-top-fwd-enter'}`}
      >
        <div className="header">
          <h2>Editar Usuário </h2>
          <span
            className="closeModal"
            onClick={() => {
              setExitModal(!exitModal);
              setTimeout(() => {
                setModalEditUser(!modalEditUser);
                setExitModal(false);
              }, 500);
            }}
          >
            x
          </span>
        </div>
        <ul>
          <li>
            <label htmlFor="NameCreatingPivo">Email</label>
            <input
              id="NameCreatingPivo"
              type="email"
              required={true}
              defaultValue={userInfo.email}
              {...register('email')}
            />
            <span className="error">{errors?.email?.message}</span>
          </li>
          <li>
            <label htmlFor="latitudeCreatingPivo">Username</label>
            <input
              type="text"
              id="latitudeCreatingPivo"
              {...register('usuario')}
              defaultValue={userInfo.usuario}
            />
            <span className="error">{errors?.usuario?.message}</span>
          </li>
          <li>
            <label htmlFor="nome">Nome</label>
            <input type="text" id="nome" {...register('nome')} defaultValue={userInfo.nome} />
            <span className="error">{errors?.nome?.message}</span>
          </li>
          <li>
            <label htmlFor="matricula">matricula</label>
            <input
              type="text"
              id="matricula"
              {...register('matricula')}
              defaultValue={userInfo.matricula}
            />
            <span className="error">{errors?.matricula?.message}</span>
          </li>
          <li className="redioInput">
            <label>Conta Ativa</label>
            <div className="radio-container">
              <label>
                <input
                  type="radio"
                  name="is_active"
                  value={true}
                  {...register('is_active')}
                  defaultChecked={userInfo.is_active}
                />{' '}
                Sim
              </label>
              <label>
                <input
                  type="radio"
                  name="is_active"
                  value={false}
                  {...register('is_active')}
                  defaultChecked={!userInfo.is_active}
                />{' '}
                Não
              </label>
            </div>
            <span className="error">{errors?.is_active?.message}</span>
          </li>
          <li className="redioInput">
            <label>Admin</label>
            <div className="radio-container">
              <label>
                <input
                  type="radio"
                  name="is_superuser"
                  value={true}
                  {...register('is_superuser')}
                  defaultChecked={userInfo.is_superuser}
                />{' '}
                Sim
              </label>
              <label>
                <input
                  type="radio"
                  name="is_superuser"
                  value={false}
                  {...register('is_superuser')}
                  defaultChecked={!userInfo.is_superuser}
                />{' '}
                Não
              </label>
            </div>
            <span className="error">{errors?.is_superuser?.message}</span>
          </li>
        </ul>
        <button type="submit">Salvar Alterações</button>
      </form>
    </ModalCreatingUser>
  );
};

export const ModalUpdatePassword = () => {
  const { modaUpdatePassword, setModalUpdatePassword, handleUserUpdate } = useContext(AdminContext);
  const [exitModal, setExitModal] = useState(false);
  const [viewPassword, setViewPassword] = useState('password');
  const [viewPassword2, setViewPassword2] = useState('password');

  const formSchema = yup.object().shape({
    password: yup.string().required('Senha Obrigatório'),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('password'), null], 'Senhas diferentes')
      .required('Senha Obrigatório'),
  });

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(formSchema),
  });

  return (
    <ModalCreatingUser
      onClick={() => {
        setExitModal(!exitModal);
        setTimeout(() => {
          setModalUpdatePassword(!modaUpdatePassword);
          setExitModal(false);
        }, 500);
      }}
    >
      <form
        onSubmit={handleSubmit(handleUserUpdate)}
        onClick={(e) => {
          e.stopPropagation(); // Impede a propagação do evento de clique para os elementos pai
        }}
        action=""
        className={`${exitModal ? 'slide-out-fwd-center-exit' : 'slide-in-elliptic-top-fwd-enter'}`}
      >
        <div className="header">
          <h2>Senha</h2>
          <span
            className="closeModal"
            onClick={() => {
              setExitModal(!exitModal);
              setTimeout(() => {
                setModalUpdatePassword(!modaUpdatePassword);
                setExitModal(false);
              }, 500);
            }}
          >
            x
          </span>
        </div>
        <ul>
          <li>
            <label htmlFor="longitudeCreatingPivo">Nova Senha</label>
            <input
              id="longitudeCreatingPivo"
              type={viewPassword}
              required={true}
              {...register('password')}
            />
            <span className="error">{errors?.password?.message}</span>
            {viewPassword === 'password' ? (
              <FaEye className="viewPassword" onClick={() => setViewPassword('text')} />
            ) : (
              <FaEyeSlash className="viewPassword" onClick={() => setViewPassword('password')} />
            )}
          </li>
          <li>
            <label htmlFor="tamanhoCreatingPivo">Confimar Senha</label>
            <input
              id="tamanhoCreatingPivo"
              type={viewPassword2}
              required={true}
              {...register('confirmPassword')}
            />
            <span className="error">{errors?.confirmPassword?.message}</span>
            {viewPassword2 === 'password' ? (
              <FaEye className="viewPassword" onClick={() => setViewPassword2('text')} />
            ) : (
              <FaEyeSlash className="viewPassword" onClick={() => setViewPassword2('password')} />
            )}
          </li>
        </ul>
        <button type="submit">Alterar Senha</button>
      </form>
    </ModalCreatingUser>
  );
};

export const ModalConfirmChangesTanque = () => {
  const { setModalConfimation, salveTanqueInfo } = useContext(AdminContext);
  const { headerApi } = useContext(HomeContext);

  const handleUpdateControllerPivo = async (id, dataTanque) => {
    try {
      dataTanque.latitude = Number(dataTanque.latitude);
      dataTanque.longitude = Number(dataTanque.longitude);
      dataTanque.nivel_maximo = Number(dataTanque.nivel_maximo);
      dataTanque.nivel_minimo = Number(dataTanque.nivel_minimo);
      delete dataTanque.quantidade_bombas;
      delete dataTanque.gtw_tanque;
      delete dataTanque.unidade;
      delete dataTanque.id;
      delete dataTanque.nivel_atual;
      delete dataTanque.usuario_tanque;
      delete dataTanque.bombas;
      delete dataTanque.automatico;
      delete dataTanque.updatedAt;
      delete dataTanque.createdAt;
      const response = await apiJalles.patch(`/tanque/${id}/`, dataTanque, headerApi);
      toast.success('Alteraçoes feitas com sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
      toast.warn('Falha', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } finally {
      setModalConfimation(false);
    }
  };

  return (
    <ModalConfirmController>
      <div className="deleteContact">
        <h2>{`Tem certeza de que deseja Salvar as alterações Feitas`}</h2>
        <div>
          <button
            className="buttonYes"
            onClick={() => {
              handleUpdateControllerPivo(salveTanqueInfo[0], salveTanqueInfo[1]);
            }}
          >
            Sim
          </button>
          <button onClick={() => setModalConfimation(false)}>Não</button>
        </div>
      </div>
    </ModalConfirmController>
  );
};

export const BombasTanques = ({ tanqueInfo }) => {
  const { setModalBombaTaque, salveTanqueInfo } = useContext(AdminContext);

  const { headerApi } = useContext(HomeContext);

  const [editedBomba, SetEditedBomba] = useState({});
  const [saveFuntionUpdateBomba, setSaveFuntionUpdateBomba] = useState([]);
  const [modalConfimationCreatBomba, SetModalConfimationCreatBomba] = useState(false);
  const [modalConfimationDeleteBomba, SetModalConfimationDeleteBomba] = useState(false);
  const [modalConfirmationChanges, setModalConfirmationChanges] = useState(false);
  const [idDelete, setIdDelete] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e, bombaId, type) => {
    SetEditedBomba((prevEditedTanque) => ({
      ...prevEditedTanque,
      [bombaId]: {
        ...prevEditedTanque[bombaId],
        [type]: e,
      },
    }));
  };

  const updateBomba = async (idBomba, data) => {
    setLoading(true);
    const token = localStorage.getItem('connectionsToken');
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      data.rotacaoNominal = Number(data.rotacaoNominal);
      data.rotacaoMaxima = Number(data.rotacaoMaxima);
      data.vazaoMax = Number(data.vazaoMax);
      data.vazaoMin = Number(data.vazaoMin);

      const response = await apiJalles.patch(`/tanques/bomba/${idBomba}`, data, headerApi);
      toast.success('Alterações feitas com sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
      toast.warn('Algo deu Errado', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    } finally {
      setModalConfirmationChanges(false);
      setLoading(false);
    }
  };

  const creatBomba = async () => {
    setLoading(true);

    try {
      const response = await apiJalles.post('/bomba', { tanque: salveTanqueInfo[0] }, headerApi);
      await apiJalles.post('/bomba/controle', { bomba: response.data.id }, headerApi);
      toast.success('Bomba criada com sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
      toast.warn('Algo deu Errado', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    } finally {
      SetModalConfimationCreatBomba(false);
      setLoading(false);
    }
  };

  const deleteBomba = async (id) => {
    setLoading(true);

    try {
      await apiJalles.delete(`/bomba/delete/${id}`, headerApi);
      toast.success('Bomba Deletada com sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
      toast.warn('Algo deu Errado', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    } finally {
      SetModalConfimationDeleteBomba(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    const initialEditedBomba = {};
    tanqueInfo[1].bombas.forEach((tanque) => {
      initialEditedBomba[tanque.id] = { ...tanque };
    });
    SetEditedBomba(initialEditedBomba);

    // console.log(initialEditedBomba[1]?.tipo_bomba);
  }, []);

  return (
    <ModalBombaTanque>
      {loading && <SquareLoading />}
      {modalConfirmationChanges && (
        <div className="confimation">
          <div className="ConfirmationChanges">
            <h2>{`Tem certeza de que deseja Salvar as Alteração`}</h2>
            <div>
              <button
                className="buttonYes"
                onClick={() => {
                  updateBomba(saveFuntionUpdateBomba[0], saveFuntionUpdateBomba[1]);
                }}
              >
                Sim
              </button>
              <button onClick={() => setModalConfirmationChanges(false)}>Não</button>
            </div>
          </div>
        </div>
      )}
      {modalConfimationCreatBomba && (
        <div className="confimation">
          <div className="ConfirmationChanges">
            <h2>{`Tem certeza que deseja criar nova Bomba`}</h2>
            <div>
              <button
                className="buttonYes"
                onClick={() => {
                  creatBomba();
                }}
              >
                Sim
              </button>
              <button onClick={() => SetModalConfimationCreatBomba(false)}>Não</button>
            </div>
          </div>
        </div>
      )}
      {modalConfimationDeleteBomba && (
        <div className="confimation">
          <div className="ConfirmationChanges">
            <h2>{`Tem certeza que deseja Deletar Bomba`}</h2>
            <div>
              <button
                className="buttonYes"
                onClick={() => {
                  deleteBomba(idDelete);
                }}
              >
                Sim
              </button>
              <button onClick={() => SetModalConfimationDeleteBomba(false)}>Não</button>
            </div>
          </div>
        </div>
      )}

      <div className="conteiner">
        <span className="closeModal">
          <IoCloseCircleOutline
            onClick={() => {
              setModalBombaTaque(false);
            }}
          />
        </span>
        <h3>{tanqueInfo[1].nome_tanque}</h3>
        <span className="creatNivel" onClick={() => SetModalConfimationCreatBomba(true)}>
          <MdAddToPhotos className="icon" /> Criar nova Bomba
        </span>
        <ul>
          {tanqueInfo[1].bombas.map((bomba) => {
            const cancelChanges = () => {
              SetEditedBomba((prevEditedTanques) => ({
                ...prevEditedTanques,
                [bomba.id]: {
                  ...prevEditedTanques[bomba.id],
                  potencia: bomba.potencia,
                  rotacaoMaxima: bomba.rotacaoMaxima,
                  rotacaoNominal: bomba.rotacaoNominal,
                  vazaoMax: bomba.vazaoMax,
                  vazaoMin: bomba.vazaoMin,
                },
              }));
            };
            const checkChangesTanque =
              JSON.stringify(bomba) === JSON.stringify(editedBomba[bomba.id]);
            return (
              <li>
                <MdOutlineDeleteSweep
                  className="deleteBomba"
                  onClick={() => {
                    setIdDelete(bomba.id);
                    SetModalConfimationDeleteBomba(true);
                  }}
                />
                <span className="IdBomba">Bomba id {bomba.id}</span>
                <div className="infosPivo">
                  <label htmlFor={`${bomba.id}modelo`}>Modelo da Bomba</label>
                  <input
                    type="text"
                    id={`${bomba.id}modelo`}
                    value={editedBomba[bomba.id]?.modelo}
                    onChange={(e) => handleInputChange(e.target.value, bomba.id, 'modelo')}
                  />
                </div>
                <div className="infosPivo">
                  <label htmlFor={`${bomba.id}tipo_bomba`}>Tipo de Bomba</label>
                  <input
                    type="text"
                    id={`${bomba.id}tipo_bomba`}
                    value={editedBomba[bomba.id]?.tipo_bomba}
                    onChange={(e) => handleInputChange(e.target.value, bomba.id, 'rotacaoNominal')}
                  />
                </div>
                <div className="buttons">
                  <button
                    className={checkChangesTanque ? 'off' : ''}
                    disabled={checkChangesTanque}
                    onClick={() => {
                      setModalConfirmationChanges(true);
                      // setSalveTanqueInfo([tanque.id, editedTanques[tanque.id]]);
                      setSaveFuntionUpdateBomba([bomba.id, editedBomba[bomba.id]]);
                    }}
                  >
                    Salvar
                  </button>
                  <button
                    className={checkChangesTanque ? 'off' : ''}
                    disabled={checkChangesTanque}
                    onClick={() => cancelChanges()}
                  >
                    Cancelar
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </ModalBombaTanque>
  );
};

export const CreatingTanque = () => {
  const { setModalCreatTanque } = useContext(AdminContext);
  const [exitModal, setExitModal] = useState(false);

  const [Unidades, setUnidades] = useState([]);
  const [loading, setloading] = useState(false);

  const ListUnidades = async () => {
    setloading(true);
    try {
      const token = sessionStorage.getItem('connectionsToken');

      const headerApi = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await apiJalles.get('/unidade/leituratodos', headerApi);
      setUnidades(response.data);
    } catch (error) {
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    ListUnidades();
  }, []);

  const formSchema = yup.object().shape({
    nome_tanque: yup.string().max(55).required('Nome do Tanque obrigatório'),
    nivel_minimo: yup.number().required('Altura Obrigatória'),
    nivel_maximo: yup.number().required('Altura Util Obrigatória'),
    unidade: yup.number().required('Unidade Obrigatória'),
  });

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(formSchema),
  });

  const creatingTanque = async (data) => {
    const token = sessionStorage.getItem('connectionsToken');
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      await apiJalles.post('/tanque', data, headerApi);

      toast.success('Tanque criado com sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });

      setExitModal(!exitModal);
      setTimeout(() => {
        setModalCreatTanque(false);
        setExitModal(false);
      }, 500);
    } catch (error) {
      toast.warn('Algo deu Errado', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
      setExitModal(!exitModal);
      setTimeout(() => {
        setModalCreatTanque(false);
        setExitModal(false);
      }, 500);
    }
  };

  return (
    <ModalCreatingTanque>
      <form
        onSubmit={handleSubmit(creatingTanque)}
        onClick={(e) => {
          e.stopPropagation();
        }}
        action=""
        className={`${exitModal ? 'slide-out-fwd-center-exit' : 'slide-in-elliptic-top-fwd-enter'}`}
      >
        <div className="header">
          <h2>Criar Tanque</h2>
          <span
            className="closeModal"
            onClick={() => {
              setExitModal(!exitModal);
              setTimeout(() => {
                setModalCreatTanque(false);
                setExitModal(false);
              }, 500);
            }}
          >
            x
          </span>
        </div>
        <ul>
          <li>
            <label htmlFor="NameCreatingPivo">Nome do Tanque</label>
            <input id="NameCreatingPivo" type="text" {...register('nome_tanque')} />
          </li>
          <li>
            <label htmlFor="altura_utilCreatingTanque">Nível Máximo</label>
            <input
              id="altura_utilCreatingTanque"
              type="number"
              defaultValue={100}
              {...register('nivel_maximo', { pattern: /^-?\d*(\.\d+)?$/ })}
            />
          </li>
          <li>
            <label htmlFor="alturaCreatingTanque">Nível Mínimo</label>
            <input
              type="text"
              defaultValue={0}
              {...register('nivel_minimo', { pattern: /^-?\d*(\.\d+)?$/ })}
              id="alturaCreatingTanque"
            />
          </li>
          <li>
            <label htmlFor="SelectUnidade">Selecione o Unidade</label>
            <select id="SelectUnidade" {...register('unidade')}>
              <option value="">Selecione...</option>
              {Unidades.map((Unidade) => {
                return <option value={Unidade.id}>{Unidade.name}</option>;
              })}
            </select>
          </li>
        </ul>
        <button type="submit">Criar Tanque</button>
      </form>
    </ModalCreatingTanque>
  );
};
